import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { useSelector, useDispatch } from "react-redux";
import { Link, useHistory } from 'react-router-dom';
import { setOpenMenuAction } from '../../../modules/common/headerModule';
import HoverLinkBtn from '../button/HoverLinkBtn';
import { setBrandSelDataResetAction } from '../../../modules/common/brandModule';
import { resetCateInfoAction } from '../../../modules/common/cateModule';
import { logoutAction } from '../../../modules/su/userModule';
import { clearUserCartAction } from '../../../modules/su/userCartModule';
import {isMobileOnly, isIOS} from 'react-device-detect';
import { resetItemStatus } from '../../../modules/es/esItemModule';
/**
 * Header 햄버거 메뉴 선택시 표시 되는 메뉴
 */
const HeaderMenuBlock = styled.div`
    position: fixed;
    top: 0;
    left: ${props => props.active ? '0' : '100%'};
    width: 100vw;
    height: 120vh;
    background-color: #fff;
    -webkit-transition: left 0.8s ease-in-out, opacity 1.2s;
    -o-transition: left 0.8s ease-in-out, opacity 1.2s;
    transition: left 0.8s ease-in-out, opacity 1.2s;
    opacity: ${props => props.active ? '1' : '0'};
    z-index: 10;
    -webkit-overflow-scrolling: touch;
    overflow-y: scroll;
    transform: translate3d(0,0,0);
`;

const HeaderWhiteBlock = styled.div`
    position: fixed;
    top: 0;
    width: 100vw;
    height: 60px;
    background-color: #fff;
    z-index: 11;
    transform: translate3d(0,0,0);
`;

const HeaderMenuContainerBlock = styled.div`
    height: 100vh;
    overflow: scroll;
    position: relative;
    z-index: 10;
`;

const HeaderMenuTop1Block = styled.div`
    //width: 142px;
    height: 36px;
    margin: 60px 30px 10px 30px;
    font-family: NotoSansKR;
    font-size: 24px;
    font-weight: bold;
    font-stretch: normal;
    font-style: normal;
    line-height: 36px;
    letter-spacing: normal;
    text-align: left;
    color: #111111;
`;

const HeaderMenuTop1LoginBlock = styled.div`
    margin: 60px 30px 4px 30px;
    font-family: NotoSansKR;
    font-size: 24px;
    font-weight: bold;
    font-stretch: normal;
    font-style: normal;
    line-height: 36px;
    letter-spacing: normal;
    text-align: left;
    color: #111111;
`;

const HeaderMenuTop2Block = styled.div`
    //width: 190px;
    max-height: 53px;
    margin: 0px 0px 0px 30px;
    font-family: NotoSansKR;
    font-size: 18px;
    font-weight: 500;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.44;
    letter-spacing: normal;
    text-align: left;
    color: #111111;
`;

const HeaderMenuLoginBtnBlock = styled.div`
    //position: absolute;
    //top: 128px;
    //right: 30px;
    ////border-radius: 50%;
    ////width: 68px;
    ////height: 68px;
    //width: 100px;
    //height: 84px;
    float: right;
    width: 100%;
    position: relative;  
    .container { 
      position: relative;
      .logo {
        width: 100px;
        position: absolute;
        top: -47px;
        //right: -4vw;
        right: 0;
      }
      .ci-name {
        position: absolute;
        top: 10px;
        //right: 60px;
        right: 73px;
        width: 35px;
      }
    }
    //background-color: #ffc742;
`;

const HeaderMenuBottomLineBlock = styled.div`
    //width: 315px;
    height: 0;
    margin: 61px 30px 0;
    border-bottom: solid 1px #cccccc;
`;

const HeaderMenuBottomLine2Block = styled.div`
    //width: 315px;
    height: 0;
    margin: 39px 30px 0;
    border-bottom: solid 1px #cccccc;
`;

const HeaderMenuUlBlock = styled.ul`
    margin: 30px 30px 0;
`;

const HeaderMenuLiBlock = styled.li`
    height: 27px;
    margin-bottom: 15px;
    font-size: 18px;
    font-weight: normal;
    line-height: 27px;
    color: #111111;
`;

const HeaderSubMenuLineBlock = styled.div`
    width: 10px;
    height: 0;
    margin: 30px 30px 0;
    border-bottom: solid 1px #333333;
`;

const HeaderSubMenuUlBlock = styled.ul`
    margin: 30px 30px 0;
`;

const HeaderSubMenuLiBlock = styled.li`
    margin-bottom: 9px;
    font-size: 16px;
    font-weight: normal;
    cursor: pointer;
    height: 24px;
    line-height: 24px;
    color: #333333;
`;

const HeaderBottomMenuUlBlock = styled.ul`
    margin: 33px 0px 33px 30px;
    padding-bottom: 33px;
`;

const HeaderBottomMenuLiBlock = styled.li`
    margin-right: 10px;
    font-size: 12px;
    font-weight: 300;
    cursor: pointer;
    height: 18px;
    float: left;
    line-height: 18px;
    color: #666666;
`;

const HeaderBottomLineBlock = styled.div`
    width: 0;
    height: 6.7px;
    //margin: 38.5px 0 5.8px;
    margin-top: 5px;
    border-right: solid 1px #cccccc;
    float: left;
    margin-right: 10px;
`;

const BottomBlock = styled.div`
    width: 100vw;
    height: 3vh;
`;

const HeaderMenu = () => {

    const dispatch = useDispatch();
    const history = useHistory();
    const [scrollY, setScrollY] = useState(0);

    // Redux Store에서 저장된 값을 가져옴
    var { openMenu, accessToken, nickname } = useSelector(
        ({ headerReducer, userReducer }) => ({
            openMenu: headerReducer.openMenu,
            accessToken: userReducer.accessToken,
            nickname: userReducer.nickname
        })
    );

    /* useEffect(() => {
        if(isMobileOnly && isIOS ) {
            if(openMenu) {
                if(scrollY === window.scrollY){
                    return;
                }

                let toppx = -window.scrollY+'px';

                let scrlly = window.scrollY;
                document.body.style.overflow = 'hidden';
                document.body.style.top=toppx;
                document.body.style.position= 'fixed';
                document.body.style.top=toppx;

                //document.body.style = {position:'fixed', top:'300px'}
                console.log("toppx + " + scrlly);
                setScrollY(scrlly);
            } else {
                let toppx = scrollY;

                document.body.style.overflow = 'unset';
                document.body.style.position= 'relative';
                document.body.style.top='auto';
                //document.body.scrollTop=scrollY;
                console.log("toppx + " + scrollY)
                window.scrollTo(0,scrollY);
            }
        }
    }, [openMenu,scrollY]) */

    const menuTitle = [
        // { title: '가구견적', link: '/es', menu: 'es' },
        // { title: '공간투어', link: '/st', menu: 'st' },
        { title: '카테고리', link: '/ct', menu: 'ct' },
        { title: '브랜드관', link: '/br', menu: 'br' },
        { title: '이벤트', link: '/em', menu: 'em' }
    ];

    const handleMenuClick = () => {
        dispatch(setOpenMenuAction(false));
        dispatch(setBrandSelDataResetAction()); //브랜드관 초기화
        dispatch(resetCateInfoAction()); // 카테고리 초기화
    }

    const handleLogout = () => {
        handleMenuClick();
        dispatch(logoutAction());
        dispatch(clearUserCartAction());
        dispatch(resetItemStatus());
    }

    //#2530 history back 위치 저장되어 있는 경우 처리
    const handleLogin = () => {
        dispatch(setOpenMenuAction(false));
        dispatch(setBrandSelDataResetAction()); //브랜드관 초기화
        dispatch(resetCateInfoAction()); // 카테고리 초기화
        return history.replace("/login",{ from: history.location })
    }
    const handleMyEs = () => {
        dispatch(setOpenMenuAction(false));
        history.push("/estimate/step1");
    }

    const getSubMenu = (menu) => {

        if (menu === 'es') {
            if (accessToken != null && accessToken.length > 0) {
                return (
                    <HeaderSubMenuUlBlock>
                        <HeaderSubMenuLiBlock className="nickname-block" onClick={handleMenuClick}>
                            {nickname}님
                        </HeaderSubMenuLiBlock>

                        <HeaderSubMenuLiBlock onClick={handleMenuClick}>
                            <Link to="/mycart"> 장바구니</Link>
                        </HeaderSubMenuLiBlock>

                        <HeaderSubMenuLiBlock onClick={handleMenuClick}>
                            <Link to='/es'>나의 견적</Link>
                        </HeaderSubMenuLiBlock>

                        <HeaderSubMenuLiBlock onClick={handleMenuClick}>
                            <Link to='/myclip'>나의 클립북</Link>
                        </HeaderSubMenuLiBlock>

                        <HeaderSubMenuLiBlock onClick={handleMenuClick}>
                            <Link to='/mysetting'>회원 정보 관리 </Link>
                        </HeaderSubMenuLiBlock>

                        <HeaderSubMenuLiBlock onClick={handleMenuClick}>
                            <Link to='/myquestion'>1:1 문의 내역</Link>
                        </HeaderSubMenuLiBlock>

                        <HeaderSubMenuLiBlock onClick={handleLogout}>
                            로그아웃
                        </HeaderSubMenuLiBlock>
                    </HeaderSubMenuUlBlock>
                )

            } else {
                return (
                    <HeaderSubMenuUlBlock>
                        <HeaderSubMenuLiBlock onClick={handleLogin}>
                            <a>로그인</a>
                        </HeaderSubMenuLiBlock>

                        <HeaderSubMenuLiBlock onClick={handleMenuClick}>
                            <Link to="/mycart"> 장바구니 </Link>
                        </HeaderSubMenuLiBlock>
                        <HeaderSubMenuLiBlock onClick={handleMenuClick}>
                            <Link to="/register">회원가입</Link>
                        </HeaderSubMenuLiBlock>
                    </HeaderSubMenuUlBlock>
                )
            }
        } else {

        }
    }

    return (
        <HeaderMenuBlock active={openMenu}>
            <HeaderWhiteBlock/>

            {accessToken != null && accessToken.length > 0 ?
            <HeaderMenuContainerBlock>
                <HeaderMenuTop1LoginBlock>{nickname}님</HeaderMenuTop1LoginBlock>
                <HeaderMenuTop2Block>언제든지 견적 받으세요 :-)<br/>&nbsp;</HeaderMenuTop2Block>
                <HeaderMenuLoginBtnBlock onClick={handleMyEs}>
                  <div className="container">
                    <img className="logo" alt="끄적서비스로고1" src="/assets/images/icon/go@3x.png" />
                    <img className="ci-name" alt="끄적서비스로고2" src="/assets/images/icon/kkjuk-logo-black.svg" />
                  </div>
                </HeaderMenuLoginBtnBlock>
                <HeaderMenuBottomLineBlock/>
                <HeaderMenuUlBlock>
                <HeaderMenuLiBlock key="100">
                    <HoverLinkBtn text={"끄적"}
                                  onClick={handleMyEs}
                                  bottom={isMobileOnly?'0':'2px'}
                                  height="1px"
                                  isDot={false}
                    />

                  </HeaderMenuLiBlock>
                  <HeaderMenuLiBlock key="0">
                    <HoverLinkBtn text={isMobileOnly?"견적":"가구견적"}
                                  onClick={handleMenuClick}
                                  bottom={isMobileOnly?'0':'2px'}
                                  height="1px"
                                  isDot={false} link="/es"
                                  icon="/assets/images/icon/check@3x.png"
                                  iconWidth="30px"
                                  iconHeight="34px"
                    />

                  </HeaderMenuLiBlock>
                    {
                        menuTitle.map((curitem, idx) => {
                            return (
                                <HeaderMenuLiBlock key={idx}>
                                    <HoverLinkBtn text={curitem.title}
                                        onClick={handleMenuClick}
                                        bottom="2px"
                                        height="1px"
                                        isDot={false} link={curitem.link} />

                                </HeaderMenuLiBlock>
                            );
                        })
                    }
                  <HeaderMenuLiBlock key="200">
                    <HoverLinkBtn text="스토어"
                                  onClick={handleMenuClick}
                                  bottom={isMobileOnly?'0':'2px'}
                                  height="1px"
                                  isDot={false} link="https://shop.odgagu.co.kr"
                                  external={true}
                                  icon="/assets/images/icon/store_sublogo.svg"
                                  iconValign="top"
                                  iconWidth="47px"
                                  iconHeight="20px"
                    />


                  </HeaderMenuLiBlock>

                </HeaderMenuUlBlock>
                <HeaderSubMenuLineBlock/>
                <HeaderSubMenuUlBlock>
                    <HeaderSubMenuLiBlock onClick={handleMenuClick}>
                        <Link to='/es'>나의 견적</Link>
                    </HeaderSubMenuLiBlock>
                    <HeaderSubMenuLiBlock onClick={handleMenuClick}>
                        <Link to="/mycart"> 장바구니</Link>
                    </HeaderSubMenuLiBlock>
                    <HeaderSubMenuLiBlock onClick={handleMenuClick}>
                        <Link to='/myclip'>나의 클립북</Link>
                    </HeaderSubMenuLiBlock>
                </HeaderSubMenuUlBlock>
                <HeaderBottomMenuUlBlock>
                    <HeaderBottomMenuLiBlock onClick={handleMenuClick}>
                        <Link to='/mysetting'>회원 정보 관리 </Link>
                    </HeaderBottomMenuLiBlock>
                    <HeaderBottomLineBlock/>
                    <HeaderBottomMenuLiBlock onClick={handleMenuClick}>
                        <Link to='/myquestion'>1:1 문의 내역</Link>
                    </HeaderBottomMenuLiBlock>
                    <HeaderBottomLineBlock/>
                    <HeaderBottomMenuLiBlock onClick={handleLogout}>
                        로그아웃
                    </HeaderBottomMenuLiBlock>
                </HeaderBottomMenuUlBlock>
                <BottomBlock/>
            </HeaderMenuContainerBlock>
            :
            <HeaderMenuContainerBlock>
                <HeaderMenuTop1Block>안녕하세요 :-)</HeaderMenuTop1Block>
                <HeaderMenuTop2Block>어디가구와 함께 발품없는<br/>견적을 시작하세요</HeaderMenuTop2Block>
                <HeaderMenuLoginBtnBlock onClick={handleMyEs}>
                    <div className="container">
                      <img className="logo" alt="끄적서비스로고1" src="/assets/images/icon/go@3x.png" />
                      <img className="ci-name" alt="끄적서비스로고2" src="/assets/images/icon/kkjuk-logo-black.svg" />
                    </div>
                </HeaderMenuLoginBtnBlock>
                <HeaderMenuBottomLineBlock/>
                <HeaderMenuUlBlock>

                <HeaderMenuLiBlock key="100">
                    <HoverLinkBtn text={"끄적"}
                                  onClick={handleMyEs}
                                  bottom={isMobileOnly?'0':'2px'}
                                  height="1px"
                                  isDot={false}
                    />

                  </HeaderMenuLiBlock>

                  <HeaderMenuLiBlock key="0">
                    <HoverLinkBtn text={isMobileOnly?"견적":"가구견적"}
                                  onClick={handleMenuClick}
                                  bottom={isMobileOnly?'0':'2px'}
                                  height="1px"
                                  isDot={false} link="/es"
                                  icon="/assets/images/icon/check@3x.png"
                                  iconWidth="30px"
                                  iconHeight="34px"
                    />

                  </HeaderMenuLiBlock>

                  {
                        menuTitle.map((curitem, idx) => {
                            return (
                                <HeaderMenuLiBlock key={idx}>
                                    <HoverLinkBtn text={curitem.title}
                                        onClick={handleMenuClick}
                                        bottom={isMobileOnly?'0':'2px'}
                                        height="1px"
                                        isDot={false} link={curitem.link}/>
                                </HeaderMenuLiBlock>
                            );
                        })
                    }
                  <HeaderMenuLiBlock>
                    <HoverLinkBtn text="스토어"
                                  onClick={handleMenuClick}
                                  bottom={isMobileOnly?'0':'2px'}
                                  height="1px"
                                  isDot={false} link="https://shop.odgagu.co.kr"
                                  external={true}
                                  icon="/assets/images/icon/store_sublogo.svg"
                                  iconValign="top"
                                  iconWidth="47px"
                                  iconHeight="20px"
                    />

                  </HeaderMenuLiBlock>

                </HeaderMenuUlBlock>
                <HeaderSubMenuLineBlock/>
                <HeaderSubMenuUlBlock>
                    <HeaderSubMenuLiBlock onClick={handleMenuClick}>
                        <Link to="/mycart"> 장바구니</Link>
                    </HeaderSubMenuLiBlock>
                </HeaderSubMenuUlBlock>
              <HeaderBottomMenuUlBlock>
                <HeaderBottomMenuLiBlock onClick={handleLogin}>
                  로그인
                </HeaderBottomMenuLiBlock>
                <HeaderBottomLineBlock/>
                <HeaderBottomMenuLiBlock onClick={handleMenuClick}>
                  <Link to='/register'>회원가입</Link>
                </HeaderBottomMenuLiBlock>
              </HeaderBottomMenuUlBlock>
                <BottomBlock/>
            </HeaderMenuContainerBlock>
            }


        </HeaderMenuBlock>
    );
};

export default HeaderMenu;
